import builder from '../builder';
import TimeClockCircleAlternate from '../../streamline-icons/bold/time-clock-circle-alternate.svg';

export default builder(
  'TimeClockCircleAlternateBold',
  TimeClockCircleAlternate,
);
